import _Calendar from './Calendar';

import './style';

export type { CalendarProps } from './Calendar';
export * from './type';

export const Calendar = _Calendar;
export default Calendar;
